<template>
		<div class="row">
			<div class="col-sm-7">
			<label class="admin-text" for="prod-search">Tiempo de entrega</label><br>
			<input id="prod-search" class="admin-input" type="text" v-model="form.shipping_time">
			</div>
		</div>
		<div class="admin-shipping">
			<div class="info-box-lg admin-background-second">
				<div class="custom-checkbox-gray">
			        <input type="checkbox" id="cb-ship-1" v-model="render_fedex_able">
			        <label for="cb-ship-1"><img class="img-responsive" src="../../images/fedex.png" alt="fedex"></label>
	      		</div>
	      		 <span class="text-sm">Aplica envío con FedEx para este producto</span>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-7">
			<label class="admin-text" for="prod-search">Peso</label><br>
			<input id="prod-search" class="admin-input" type="text" v-model="form.weight">
			</div>
		</div>
		<div class="row">
			<div class="col-sm-7">
			<label class="admin-text" for="prod-search">Largo</label><br>
			<input id="prod-search" class="admin-input" type="text" v-model="form.length">
			</div>
		</div>
		<div class="row">
			<div class="col-sm-7">
			<label class="admin-text" for="prod-search">Ancho</label><br>
			<input id="prod-search" class="admin-input" type="text" v-model="form.width">
			</div>
		</div>
		<div class="row">
			<div class="col-sm-7">
			<label class="admin-text" for="prod-search">Alto</label><br>
			<input id="prod-search" class="admin-input" type="text" v-model="form.height">
			</div>
		</div>
		<br>
</template>

<script>
// ------- FORM -------

var form = {
	shipping_time: '',
	fedex_able: false,
	weight: 0,
	width: 0,
	length: 0,
	height: 0
}

export default {
	// ------ PROPS ------

	props: ['form'],

	// ------ DATA ------

	data() {
		return {
			// form: form
		};
	},

	// ------ RENDER ------

	computed: {
		render_fedex_able() {
			if (this.form.fedex_able == '1') {
				return true;
			} else {
				return false;
			}
		}
	}
}
</script>

<style scoped>
	.text-sm{
		margin-left: 33px;
	}
	.info-box-lg{
		padding: 45px 15px 45px 33px;
	}
</style>


// WEBPACK FOOTER //
// Admin-products-shipping-edit.vue?6054a624